import React from 'react';
import Image, { StaticImageData } from 'next/image';
import PipCheer from '@/assets/birds/pip-cheer.png';
import PipExplorer from '@/assets/birds/pip-explorer.png';
import PipHappy from '@/assets/birds/pip-happy.png';
import PipPoint from '@/assets/birds/pip-point.png';
import PipReading from '@/assets/birds/pip-reading.png';
import PipScientist from '@/assets/birds/pip-scientist.png';
import PipTeacher from '@/assets/birds/pip-teacher.png';
import PipTrophy from '@/assets/birds/pip-trophy.png';
import PipWave from '@/assets/birds/pip-wave.png';

/**
 * Pip — the Pickatale Phonics parrot mascot. Decorative artwork from the v2
 * design-system handoff. Each pose maps to a transparent PNG.
 */
const BIRDS: Record<string, StaticImageData> = {
  cheer: PipCheer,
  explorer: PipExplorer,
  happy: PipHappy,
  point: PipPoint,
  reading: PipReading,
  scientist: PipScientist,
  teacher: PipTeacher,
  trophy: PipTrophy,
  wave: PipWave,
};

export type PipPose = keyof typeof BIRDS;

interface PipProps {
  pose: PipPose;
  alt: string;
  className?: string;
}

export const Pip = ({ pose, alt, className }: PipProps) => (
  <Image src={BIRDS[pose]} alt={alt} className={className} />
);
